import { c as _c } from "react/compiler-runtime";
import { prosConsContainer } from '../../styles';
import { ProConsList } from './ProConsList';
export const ProsCons = t0 => {
  const $ = _c(7);
  const {
    pros,
    cons
  } = t0;
  let t1;
  if ($[0] !== pros) {
    t1 = <ProConsList items={pros} type="pros" />;
    $[0] = pros;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] !== cons) {
    t2 = <ProConsList items={cons} type="cons" />;
    $[2] = cons;
    $[3] = t2;
  } else {
    t2 = $[3];
  }
  let t3;
  if ($[4] !== t1 || $[5] !== t2) {
    t3 = <div className={prosConsContainer}>{t1}{t2}</div>;
    $[4] = t1;
    $[5] = t2;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  return t3;
};